define("Modules/MenuDrawer", [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`Locale`, `User`],
		defaults: {
			render: true,
			/**
			 * callbacks.close - function to call when close is clicked.
			 */
		},
		prepare(setup) {
			const { data, Locale } = this;
			const locale = Locale.get();

			const { available: availableLocales } = locale;
			let showLanguageMenu = false;

			if (availableLocales.length > 1) {
				showLanguageMenu = true;
			}

			this.assign(data, {
				showLanguageMenu,
			});
		},
		constructor(setup) {
			const { Locale } = this;
			Locale.get({
				fireImmediately: true,
				subscribe: (locale) => {
					const { selected } = locale;
					const localeElement = this.get(`[name="locale-label"]`);

					if (this.isObject(localeElement)) {
						localeElement.innerHTML = `${selected.uniqueLabel}`;
					}
				},
			});

			return this.User.get({
				subscribe: true,
				then: function (user) {
					const isGuestUser = this.User.isGuestUser();

					if (isGuestUser) {
						this.handleLoggedOut();
					} else {
						this.handleLoggedIn(user);
					}
				},
				fail: this.handleLoggedOut,
			});
		},

		api: {
			handleLoggedIn: {
				value(user) {
					const userElement = this.get(`[name="user"]`);
					const nameElement = this.get(`.name`, userElement);

					nameElement.innerHTML = `${user.firstName} ${user.lastName}`;

					this.select(`.logged-out`).hide();
					this.select(`.logged-in`).show();
				},
			},

			handleLoggedOut: {
				value() {
					this.select(`.logged-in`).hide();
					this.select(`.logged-out`).show();
				},
			},

			close: {
				value() {
					if (this.isFunction(this.callbacks.close)) {
						this.callbacks.close();
					}
				},
			},
		},

		listeners: [
			{
				event: `click`,
				filter: `[action="close"]`,
				handler(evt) {
					this.close();
				},
			},
			{
				event: `click`,
				filter: `[action="login"]`,
				handler(evt) {
					this.App.loadOverlay({
						type: `LogIn`,
						replace: true,
						setup: {
							mode: `default`,
						},
						done: true,
					});
				},
			},
			{
				event: `click`,
				filter: `[action="signup"]`,
				handler(evt) {
					const { App } = this;

					App.loadOverlay({
						type: `SignUp`,
						replace: true,
						defer: false, // show immediately
					});
				},
			},
			{
				event: `click`,
				filter: `[action="logout"]`,
				handler(evt) {
					this.User.logOut({
						done: true,
					});
				},
			},
			{
				event: `click`,
				filter: `[action="select-locale"]`,
				handler(evt) {
					this.Locale.loadLanguageSelectionOverlay();
				},
			},
			{
				event: `click`,
				filter: `[action="navigateToSection"]`,
				handler(evt) {
					// close menu when navigating to a section
					this.close();
				},
			},
		],
	});
});

define("Modules/MenuDrawer.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/MenuDrawer/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\"#\" action=\"select-locale\" class=\"locale link\"> "
    + container.escapeExpression(lookupProperty(helpers,"getIcon").call(depth0 != null ? depth0 : (container.nullContext || {}),"earth",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2116},"end":{"line":1,"column":2135}}}))
    + "<span name=\"locale-label\" class=\"label\" translate=\"no\"></span> </a> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div name=\"sideDrawer\" class=\"side-drawer\"> <div class=\"header\"> <div class=\"logged-out\"> <div class=\"logo\"> <a href=\"/\" class=\"link\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"tixr",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":135},"end":{"line":1,"column":153}}}))
    + " </a> </div> </div> <div class=\"logged-in\"> <div name=\"user\" class=\"user\" translate=\"no\"> <span class=\"name\"></span> </div> </div> <div class=\"close\"> <a href=\"#\" action=\"close\" class=\"type-icon\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"close",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":349},"end":{"line":1,"column":368}}}))
    + "</a> </div> </div> <div class=\"user-section\"> <div class=\"logged-out\"> <a href=\"#\" name=\"login\" action=\"login\" class=\"button small ux4 primary flex-centered\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> <span>Log In</span> </a> <a href=\"#\" name=\"signup\" action=\"signup\" class=\"button small ux4 tertiary light-alt flex-centered\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> <span>Sign Up</span> </a> </div> <div class=\"logged-in\"> <a href=\"/home\" name=\"myAccount\" action=\"navigateToSection\" class=\"button ux4 complex\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> <div class=\"left\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"profile",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":889},"end":{"line":1,"column":910}}}))
    + " <div class=\"labels\"> <p class=\"primary-label\">Account</p> </div> </div> <div class=\"right\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"arrow-right",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1002},"end":{"line":1,"column":1027}}}))
    + "</div> </a> <a href=\"/home/events\" name=\"wallet\" action=\"navigateToSection\" class=\"button ux4 complex\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> <div class=\"left\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"wallet-new",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1174},"end":{"line":1,"column":1198}}}))
    + " <div class=\"labels\"> <p class=\"primary-label\">Wallet</p> </div> </div> <div class=\"right\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"arrow-right",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1289},"end":{"line":1,"column":1314}}}))
    + "</div> </a> <a href=\"/home/media\" name=\"media\" action=\"navigateToSection\" class=\"button ux4 complex\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> <div class=\"left\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"play-circle-open",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1459},"end":{"line":1,"column":1489}}}))
    + " <div class=\"labels\"> <p class=\"primary-label\">Media</p> </div> </div> <div class=\"right\">"
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"arrow-right",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1579},"end":{"line":1,"column":1604}}}))
    + "</div> </a>  </div> <hr class=\"divider logged-in\" /> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showLanguageMenu") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2035},"end":{"line":1,"column":2210}}})) != null ? stack1 : "")
    + " <a href=\"#\" action=\"logout\" class=\"logged-in logout link\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"logout",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2270},"end":{"line":1,"column":2290}}}))
    + "<span class=\"label\">Log Out</span> </a> </div> <hr class=\"divider\" /> <div class=\"menu-section\"> <a href=\"/\" name=\"discover\" class=\"link\"> <p>Discover</p> </a> <a href=\"//creators.tixr.com\" name=\"sell\" class=\"link\"> <p>Sell on Tixr</p> </a> <a href=\"//creators.tixr.com/about\" name=\"about\" class=\"link\"> <p>About Us</p> </a> <a href=\"//blog.tixr.com/news\" name=\"blog\" class=\"link\"> <p>Blog</p> </a> <a href=\"//support.tixr.com/\" name=\"support\" class=\"link\"> <p>Fan Support</p> </a> </div> <hr class=\"divider\" /> <div class=\"app-prompt\"> <h4>Get the Tixr app.</h4> <p>Download in the iOS App store or on Google Play.</p> <div class=\"app-buttons\"> <a href=\"//apps.apple.com/us/app/tixr-event-tickets/id843423849\" name=\"appStore\" class=\"button small ux4 tertiary light-alt\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"apple-logo",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3086},"end":{"line":1,"column":3110}}}))
    + "<span>iOS</span> </a> <a href=\"//play.google.com/store/apps/details?id=com.tixr.tixr&pli=1\" name=\"googlePlay\" class=\"button small ux4 tertiary light-alt\" theme=\""
    + alias2(alias3(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0))
    + "\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"android-logo",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3289},"end":{"line":1,"column":3315}}}))
    + "<span>Android</span> </a> </div> </div> </div>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=MenuDrawer.js.map